<template>
  <div class="DETAILS-LIST">
    <slot>
      <detail-item
          v-for="item in items"
          :key="item.label"
          :item-label="item.label"
          :item-value="item.value"
          :item-selenium="item.selenium"/>
    </slot>
  </div>
</template>

<script>
import DetailItem from './DetailItem';

export default {
  name: 'details-list',
  components: {
    DetailItem,
  },
  props: {
    items: {
      type: Array,
      default () {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";
  @import "./constants.scss";

  .DETAILS-LIST {
    display: grid;
    grid-template-columns: 1fr;

    & > * {
      border-bottom: 1px solid $color-gray40;
    }

    @include desktop {
      grid-template-columns: $desktop-columns;

      & > * {
        border-bottom: none;
      }
    }
  }
</style>
